export default "__VITE_ASSET__cZPYqr4c__"